var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "recommended-bands justify-content-center" },
          [
            _vm._l(_vm.bandChunks, function (bandChunk) {
              return _c(
                "div",
                { key: bandChunk.id, staticClass: "row" },
                _vm._l(bandChunk.bands, function (band) {
                  return _c(
                    "div",
                    { key: band.id, staticClass: "col-md-4 d-flex" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "recommended-bands__band-card",
                          attrs: { href: `/fi/band/${band.slug}` },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "recommended-bands__band-card__image-container",
                            },
                            [
                              band.defaultProfileImage
                                ? _c("div", {
                                    staticClass:
                                      "recommended-bands__band-card__image-container__image",
                                    style: {
                                      backgroundImage:
                                        "url('" +
                                        band.defaultProfileImage +
                                        "')",
                                    },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "recommended-bands__band-card__image-container__image",
                                    },
                                    [_c("i", { staticClass: "far fa-image" })]
                                  ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("h3", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(band.name) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "recommended-bands__band-card__info",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "recommended-bands__band-card__info__stars",
                                },
                                [
                                  _c("Stars", {
                                    attrs: { rating: band.bandRank },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "recommended-bands__band-card__info__price",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatPrice(band)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "recommended-bands__band-card__info__slogan",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(band.slogan) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "row justify-content-center recommended-bands__navigation",
              },
              [
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "div",
                    {
                      class: { disabled: _vm.isPreviousButtonDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.previousPage()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-double-left" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.nextPage()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-double-right" })]
                  ),
                ]),
              ]
            ),
          ],
          2
        )
      : _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "panel-loading col-md-4" }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }